import determineTarget from './determine-target';
import toggleElement from './toggle-element';
import historyStorage from './history-storage';

export default function setupAccordion( endpoints ) {
	function setupAccordionReset( name, value ) {
		const mediaQuery = window.matchMedia( value );

		function resetAccordions() {
			const toggles = document.querySelectorAll( `.js-${ name }-toggle` );
			const contents = document.querySelectorAll( `.js-${ name }-accordion` );

			if ( mediaQuery.matches ) {
				toggles.forEach( toggle => toggle.setAttribute( 'aria-expanded', true ) );
				contents.forEach( content => content.setAttribute( 'aria-hidden', false ) );
			} else {
				toggles.forEach( toggle => toggle.setAttribute( 'aria-expanded', false ) );
				contents.forEach( content => content.setAttribute( 'aria-hidden', true ) );
			}
		}

		resetAccordions();
		if ( typeof mediaQuery.addEventListener === 'undefined' ) {
			mediaQuery.addListener( resetAccordions );
		} else {
			mediaQuery.addEventListener( 'change', resetAccordions );
		}

		return mediaQuery;
	}

	const accordionEndpoints = endpoints.map( ( { name, value } ) => {
		return {
			name,
			mediaQuery: setupAccordionReset( name, value ),
		};
	} );

	document.addEventListener( 'click', event => {
		let toggle = event.target;

		// If not the literal toggle, check if it's a decendent of one
		if ( ! toggle.classList.contains( 'js-accordion-toggle' ) ) {
			toggle = toggle.closest( '.js-accordion-toggle' );
		}

		// No match, ignore event
		if ( ! toggle ) {
			return;
		}

		// Check breakpoints
		const endpointMatch = accordionEndpoints.find( ( { name, mediaQuery } ) => {
			return toggle.classList.contains( `js-${ name }-toggle` ) && mediaQuery.matches;
		} );
		if ( endpointMatch ) {
			return;
		}

		event.preventDefault();

		// Get target, abort if not found
		const content = determineTarget( toggle );
		if ( ! content ) {
			return;
		}

		// Toggle status
		const show = toggle.getAttribute( 'aria-expanded' ) === 'false';

		// Toggle status
		if ( show ) {
			// Animate to "auto" height
			content.style.setProperty( '--open-height', `${ content.scrollHeight }px` );

			// If it's within a group, close all others
			const group = toggle.closest( content.classList.contains( 'js-tab-panel' ) ? '.js-accordion-group.js-tab-set' : '.js-accordion-group:not(.js-tab-set)' );
			if ( group ) {
				group.querySelectorAll( '.js-accordion-toggle[aria-expanded="true"]' )
					.forEach( otherToggle => {
						// Don't change the current toggle
						if ( otherToggle === toggle ) {
							return;
						}

						// Get target content, animate from current height
						const otherContent = determineTarget( otherToggle );
						otherContent.style.setProperty( '--open-height', `${ otherContent.clientHeight }px` );

						// Mark as closed
						toggleElement( otherContent, false );
					} );
			}
		} else {
			// Animate from current height
			content.style.setProperty( '--open-height', `${ content.clientHeight }px` );
		}

		// Mark as open/close
		toggleElement( content, show );
		historyStorage.setItem( content.id, show );
	} );

	// Initialize accordion expanded states
	document.querySelectorAll( '.js-accordion-toggle' )
		.forEach( toggle => {
			// Check breakpoints
			const endpointMatch = accordionEndpoints.find( ( { name, mediaQuery } ) => {
				return toggle.classList.contains( `js-${ name }-toggle` ) && mediaQuery.matches;
			} );
			if ( endpointMatch ) {
				return;
			}

			const content = determineTarget( toggle );
			let open = historyStorage.getItem( content.id );
			if ( open === null ) {
				// Mark as open/closed based on auto-open class
				open = toggle.classList.contains( 'auto-open' );
			}
			toggleElement( content, open );
		} );
}
